/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgAuthProviderCreationBtn from '../views/organization/authProviders/OrgAuthProviderCreationBtn';
import OrgAuthProvidersList from '../views/organization/authProviders/OrgAuthProvidersList';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { getAllOrgsAuthProvidersByOrgID } from '../../../../../store/reducers/organization/orgAuthProvider/orgAuthProviderAction';

const ManageOrganizationAuthProvidersPage = () => {
    const [loading, setLoading] = useState(false);
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const fetchOrgsAuthProvider = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgsAuthProvidersByOrgID({ 'organizationID': orgid })).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch, orgid])
    useEffect(() => {
        fetchOrgsAuthProvider()
    }, [fetchOrgsAuthProvider]);

    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organization Identity Providers'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAuthProviderCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAuthProvidersList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrganizationAuthProvidersPage; 